import { useEffect, useRef } from 'react';
type WSProps = {
  url: string;
  token?: string;
  onOpen: AnyFunc;
  onMessage: AnyFunc;
  onClose?: AnyFunc;
  maxReconnectCallBack?: AnyFunc;
  socketBinaryType?: 'arraybuffer' | 'blob';
};

const WebsocketCmp = (props: WSProps) => {
  const wsClient: any = useRef(null);
  const _reconnectCount: React.MutableRefObject<number> = useRef(0);
  const autoReconnect: React.MutableRefObject<boolean> = useRef(true);
  const {
    url,
    onOpen,
    onMessage,
    onClose,
    maxReconnectCallBack,
    token,
    socketBinaryType = 'blob',
  } = props;
  useEffect(() => {
    createWebsocket();
    return () => {
      autoReconnect.current = false;
      wsClient.current.close();
      wsClient.current = null;
    };
  }, []);
  const createWebsocket = () => {
    wsClient.current = token ? new WebSocket(url, token) : new WebSocket(url);
    wsClient.current.binaryType = socketBinaryType;
    wsClient.current.onopen = () => {
      onOpen && onOpen(wsClient);
    };
    wsClient.current.onerror = (event: Event) => {
      console.error('LocalView WebSocket Error:', event);
    };
    wsClient.current.onclose = (event: any) => {
      console.log('LocalView connection closed', event);
      if (!autoReconnect.current) {
        return;
      }
      onClose && onClose(event);
      if (_reconnectCount.current > 10) {
        maxReconnectCallBack && maxReconnectCallBack();
        return;
      }
      setTimeout(() => {
        _reconnectCount.current++;
        createWebsocket();
      }, 5000);
    };
    wsClient.current.onmessage = (event: any) => {
      onMessage && onMessage(event.data);
    };
  };
  return null;
};

export default WebsocketCmp;
